import EventEmitter from 'eventemitter3';
import fromEventEmitter from '../event-emitter.js';
import pDefer from 'p-defer';
const createAtomMock = (options = {}) => {
    const { defaultValue } = options;
    let latestValue = defaultValue;
    const emitter = new EventEmitter();
    const initialized = pDefer();
    const get = async () => {
        if (!('defaultValue' in options)) {
            await initialized.promise;
        }
        return latestValue;
    };
    const set = async (data) => {
        latestValue = data;
        if (data !== undefined) {
            initialized.resolve();
            initialized.resolved = true;
        }
        if (initialized.resolved) {
            emitter.emit('data', data);
        }
    };
    return fromEventEmitter({
        ...options,
        getInitialized: () => initialized.resolved,
        emitter,
        event: 'data',
        get,
        set,
    });
};
export default createAtomMock;
